import { createI18n } from 'vue-i18n';
// пока не используем en
// import en from "../../../i18n/en.json";
// import enBackend from "../../../i18n/en.backend.json";
import ru from "../../../i18n/ru.json";
import ruBackend from "../../../i18n/ru.backend.json";

export const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    // пока не используем en
    // locale: window.locale,
    locale: 'ru',
    formatFallbackMessages: false,
    // отключаем нотайсы html в переводах
    warnHtmlInMessage: false,
    messages: {
        // пока не используем en
        // en: {
        //     lang: en,
        //     backend: enBackend,
        // },
        ru: {
            lang: ru,
            backend: ruBackend,
        }
    },
    // Ключ - язык, для которого будет применяться правило
    // Value - функция плюрализации
    pluralRules: {
        /**
         * @param choice {number} индекс выбора, переданный в $t: `$t('path.to.rule', choiceIndex)`
         * @param choicesLength {number} общее количество доступных вариантов
         * @returns финальный индекс для выбора соответственного варианта слова
         */
        ru: (choice, choicesLength) => {
            // this === VueI18n экземпляра, так что свойство locale также существует здесь

            if (choice === 0) {
                return 0;
            }

            const teen = choice > 10 && choice < 20;
            const endsWithOne = choice % 10 === 1;

            if (choicesLength < 4) {
                return (!teen && endsWithOne) ? 1 : 2;
            }
            if (!teen && endsWithOne) {
                return 1;
            }
            if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
                return 2;
            }

            return (choicesLength < 4) ? 2 : 3;
        }
    }
});
